import { createContext, type ReactNode } from "react";
import type { PortalSignedIn } from "./PortalLayout";

/**
 * Lets the shared account menu (packages/portal-ui `AccountMenu`, docs/features/portal-sign-in/09 5.8) take the place of
 * the portal's own menu in the header. Absent: the portal's own `ViewerMenu`, as before. Mock-up phase: the portal
 * layout reads it; the stories of the `home.*` cases provide it.
 */
export const PortalAccountMenuContext = createContext<
  ((signedIn: PortalSignedIn) => ReactNode) | null
>(null);
